// @core/api/endpoints/platform/get_platform_limits.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlatformLimitsResponse,
} from '../../../types/platform';

const BASE_PATH = '/platform';

/**
 * Get platform resource limits
 * Retrieves the platform's resource limits including maximum members, storage quotas, and API rate limits based on the subscription tier.
 */
export async function GetPlatformLimits(
  platform_id: string,
  options?: RequestOptions
): Promise<PlatformLimitsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/limits`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.get<PlatformLimitsResponse>(requestPath, { ...requestOptions });
}
